import {BaseSingleInputComponent, BaseSingleInputComponentController} from "../baseSingleInput.component";

export interface ITextInputBindings {
    uiMaskPlaceholderCharBinding: string;
    uiMaskBinding: string;
    placeholderTextBinding: string;
}

export class TextInputComponent extends BaseSingleInputComponent {
    protected getController(): typeof BaseSingleInputComponentController {
        return TextInputComponentController;
    }

    protected getTemplateUrl(): string {
        return './modules/quoteWizard/components/singleInputComponents/text/textInput.view.html';
    }

    protected getBindings(): any {
        return {
            uiMaskPlaceholderCharBinding: '@',
            uiMaskBinding: '@',
            placeholderTextBinding: '@'
        };
    }
}

// internal interface between the component and the controller -- this is the controller's API
interface ITextInputComponentController extends ITextInputBindings {
    goNext(): void;

    goBack(): void;

    currentStateNameSuffix: string;
}

// tslint:disable-next-line:max-classes-per-file
export class TextInputComponentController extends BaseSingleInputComponentController implements ITextInputComponentController {
    public uiMaskPlaceholderCharBinding: string;
    public uiMaskBinding: string;
    public placeholderTextBinding: string;

    public currentStateNameSuffix: string;

    public static $inject = ['$scope', 'ValidationService', '$state'];

    constructor($scope: any, validationService: any, $state?: angular.ui.IStateService) {
        super($scope, validationService);
        this.currentStateNameSuffix = $state.current.name.split('.').pop();
    }
}
